// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__gaW4g","ellipsis":"styles_ellipsis__vKxbo","text2AndMoreLines":"styles_text2AndMoreLines__tUae3","tooltipTrigger":"styles_tooltipTrigger__R_1UK"};